import KB from '@kb/global-context';
import { useTranslation } from '@kb/i18n';
import { useMutation } from '@ocp/graphql-client';
import { notifyDanger, notifySuccess } from '@ocp/notifications';
import i18nKeys from '../i18n/index';
const ADD_TO_COMPARISON_MUTATION = `
  mutation AddContentToComparison($entries: [InputNewContentComparisonEntry]) {
    addContentsToComparison(newContentComparisonEntries: $entries)
  }
`;
export default function useAddToComparisonMutation(classNameId, classPk, successMessage, comparisonPageUrl, onConflict) {
    const { t } = useTranslation();
    return useMutation(ADD_TO_COMPARISON_MUTATION, {
        variables: {
            entries: [{ classNameId, classPk }],
        },
        onCompleted: () => {
            notifySuccess(successMessage);
            if (comparisonPageUrl) {
                KB.navigatePath(comparisonPageUrl);
            }
        },
        onError: (e) => {
            var _a, _b;
            const isThereComparisonConflict = ((_b = (_a = e.graphQLErrors[0]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.code) === 400;
            if (isThereComparisonConflict) {
                onConflict === null || onConflict === void 0 ? void 0 : onConflict();
            }
            else {
                console.error(e);
                notifyDanger(t(i18nKeys.ERROR_IS_OCCURED));
            }
        },
    });
}
